var t = {};
function e() {
  return t;
}
export {
  e as getDefaultOptions
};
